import React from 'react'

const MultiStorecashTile = ({
    rewardPrice,
    Image_Url,
    Image_alt_text,
    heading,
    Body_Html,
    endDate,
    rewardEndDate,
    skuModel,
    reward_endDate}) => {

  return (
    <>
    <div className="storecashTile__top disp-flex">
    <span className="text-bold text-info-sat fixed-text">Earn</span>
    {rewardPrice}
    <img className="disp-inline-block storecashTile__img" src={Image_Url} width='31' height='28' alt={Image_alt_text}/>
    </div>
    <div className="storecashTile__text text-size-75 line-height-xs">
    {heading ? <span>{heading} - {skuModel}</span> : <span dangerouslySetInnerHTML={{ __html: Body_Html }} />}&nbsp;
        <p>Ends {reward_endDate && reward_endDate === 'not given' ? endDate : rewardEndDate }</p>
    </div>
</>
  )
}

export default MultiStorecashTile
